var d = Object.defineProperty;
var m = (e, t, r) => t in e ? d(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var a = (e, t, r) => m(e, typeof t != "symbol" ? t + "" : t, r);
const E = [
  // Native ES errors https://262.ecma-international.org/12.0/#sec-well-known-intrinsic-objects
  EvalError,
  RangeError,
  ReferenceError,
  SyntaxError,
  TypeError,
  URIError,
  // Built-in errors
  globalThis.DOMException,
  // Node-specific errors
  // https://nodejs.org/api/errors.html
  globalThis.AssertionError,
  globalThis.SystemError
].filter(Boolean).map(
  (e) => [e.name, e]
);
new Map(E);
const h = [
  {
    property: "name",
    enumerable: !1
  },
  {
    property: "message",
    enumerable: !1
  },
  {
    property: "stack",
    enumerable: !1
  },
  {
    property: "code",
    enumerable: !0
  },
  {
    property: "cause",
    enumerable: !1
  }
], c = Symbol(".toJSON was called"), g = (e) => {
  e[c] = !0;
  const t = e.toJSON();
  return delete e[c], t;
}, p = ({
  from: e,
  seen: t,
  to: r,
  forceEnumerable: s,
  maxDepth: i,
  depth: u,
  useToJSON: f,
  serialize: b
}) => {
  if (r || (Array.isArray(e) ? r = [] : r = {}), t.push(e), u >= i)
    return r;
  if (f && typeof e.toJSON == "function" && e[c] !== !0)
    return g(e);
  const l = (n) => p({
    from: n,
    seen: [...t],
    forceEnumerable: s,
    maxDepth: i,
    depth: u,
    useToJSON: f,
    serialize: b
  });
  for (const [n, o] of Object.entries(e)) {
    if (typeof Buffer == "function" && Buffer.isBuffer(o)) {
      r[n] = "[object Buffer]";
      continue;
    }
    if (o !== null && typeof o == "object" && typeof o.pipe == "function") {
      r[n] = "[object Stream]";
      continue;
    }
    if (typeof o != "function") {
      if (!o || typeof o != "object") {
        r[n] = o;
        continue;
      }
      if (!t.includes(e[n])) {
        u++, r[n] = l(e[n]);
        continue;
      }
      r[n] = "[Circular]";
    }
  }
  for (const { property: n, enumerable: o } of h)
    typeof e[n] < "u" && e[n] !== null && Object.defineProperty(r, n, {
      value: O(e[n]) ? l(e[n]) : e[n],
      enumerable: !0,
      configurable: !0,
      writable: !0
    });
  return r;
};
function S(e, t = {}) {
  const {
    maxDepth: r = Number.POSITIVE_INFINITY,
    useToJSON: s = !0
  } = t;
  return typeof e == "object" && e !== null ? p({
    from: e,
    seen: [],
    forceEnumerable: !0,
    maxDepth: r,
    depth: 0,
    useToJSON: s,
    serialize: !0
  }) : typeof e == "function" ? `[Function: ${e.name ?? "anonymous"}]` : e;
}
function O(e) {
  return !!e && typeof e == "object" && "name" in e && "message" in e && "stack" in e;
}
class y extends Error {
  /**
   * @param message Error message, as displayed in the logs
   * @param data Custom metadata added in the logs
   */
  constructor(r, s) {
    super(r);
    a(this, "data");
    a(this, "cause");
    this.data = s, this.name = "Oops";
  }
  /**
   * Add a cause to the current error
   * @param cause Original error
   */
  wrap(r) {
    return this.cause = r, this;
  }
  toString() {
    const { name: r, message: s, cause: i } = this;
    return !s && i !== void 0 ? `${r}: ${String(i)}` : `${r}: ${s}`;
  }
  /**
   * Returns a serializable representation of an object.
   */
  toJSON() {
    return {
      name: this.name,
      stack: this.stack,
      message: this.message,
      data: this.data,
      cause: S(this.cause)
    };
  }
}
a(y, "description");
class N extends y {
  /**
   * @param _switchCase The variable whose type should never occured
   * @param message Error message, as displayed in the logs
   * @param data Custom metadata added in the logs
   */
  constructor(t, r, s) {
    super(r, s);
  }
}
export {
  y as Oops,
  N as TypeGuardError
};
